import React from "react";
import { Container } from "react-bootstrap";
import { Grid } from "@mui/material";
import { UiWhiteCard } from "../common/UiWhiteCard";
import { UiButton } from "../common/UiButton";
import { SuccessIconLarge } from "../../../styles/img/svg/SuccessIconLarge";

export const UiSchedulePaymentIterationStop = ({ onOkClick }) => {
  return (
    <>
      <div className="df-user-profile df-transaction-confirmation">
        <Container maxWidth="md" className="df-pos-rel">
          <UiWhiteCard>
            <div className="df-confirmation-card">
              <div className="df-user-profile__body df-pw-tab df-success-pw-reset df-fd-space">
                <Grid container>
                  <Grid size={12} className="text-center">
                    <SuccessIconLarge />
                    <h2 className="df-fd-success__title text-center">
                      Payment schedule <br /> successfully stopped!
                    </h2>
                  </Grid>
                </Grid>
              </div>

              <div className="df-confirmation-card__footer">
                <UiButton
                  className="df-ui-dark-bg-btn"
                  name="Ok"
                  onClick={onOkClick}
                />
              </div>
            </div>
          </UiWhiteCard>
        </Container>
      </div>
    </>
  );
};
